import styled from "@emotion/styled";

export const CenteredContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: stretch;
`;
